import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1278b3fc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/video_chat.css?vue&type=style&index=0&id=1278b3fc&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/video_chat.css?vue&type=style&index=1&id=1278b3fc&prod&scoped=true&lang=css&"
import style2 from "@/assets/css/pc/online_status.css?vue&type=style&index=2&id=1278b3fc&prod&scoped=true&lang=css&"
import style3 from "@/assets/css/sp/online_status.css?vue&type=style&index=3&id=1278b3fc&prod&scoped=true&lang=css&"
import style4 from "./index.vue?vue&type=style&index=4&id=1278b3fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278b3fc",
  null
  
)

export default component.exports